import React from 'react'

import { usePathParams } from '~/apps/ninesegsAnalyzer/routes/paths'

import { pathKey } from '../../utils'

export const useMainQueryKey = () => {
  const { surveyId } = usePathParams(pathKey)

  return React.useMemo(
    () => ['DataSettingsPage_Main', { surveyId }],
    [surveyId],
  )
}
